import EventListener from "../frontendlib/event_listener";
import Logger from "./logger";

const overrideMethods = {
  layout: true,
  load: true,
  resize: true,
  start: true,
  stop: true,
  restart: true,
};

class Component extends EventListener {
  static init() {
    this.registry = {};
  }

  static register(name, cls) {
    if (this.registry[name] != null) {
      throw new Error(`ComponentError: ${name} already registered`);
    }

    this.assertSubclassed(cls);
    this.registry[name] = cls;
  }

  static new(name, config) {
    const cls = this.registry[name];
    if (cls == null) {
      throw new Error(`ComponentError: component "${name}" not registered`);
    }

    return new cls(config);
  }

  static assertSubclassed(cls) {
    const methods = Object.getOwnPropertyNames(this.prototype);
    methods.forEach((method) => {
      if (overrideMethods[method] !== true) return;
      if (cls.prototype[method] === this.prototype[method]) {
        throw new Error(`ComponentError: ${method} must be overridden`);
      }
    });
  }

  constructor(config) {
    super();
    this.config = config;
    this.on({
      start: () => this.start(),
      stop: () => this.stop(),
      restart: () => this.restart(),
    });
  }

  error(err) {
    this.emit("error", `${this.constructor.name}Error: ${err}`);
  }

  // The layout method should prepare the component to take up a stable size and
  // position within the DOM.
  layout(parentNode) {
    this.parentNode = parentNode;
  }

  // The load method should load assets. This is intended to capture the time it
  // takes for the component to be fully visible (all images/videos loaded).
  load() {}

  resize() {}

  start() {}

  stop() {}

  restart() {}

  recordInteraction() {
    Logger.recordMetricV2("interaction_count", 1);
  }

  recordInteractionPromptReached() {
    Logger.recordMetricV2("interaction_prompt_reached_count", 1);
    if (
      window.Liftoff != null &&
      window.Liftoff.setInteractionPromptReached != null
    ) {
      window.Liftoff.setInteractionPromptReached();
    }
  }
}

Component.init();

export default Component;



// WEBPACK FOOTER //
// ./src/js/madlib/component.js